module.exports = __webpack_public_path__ + "static/media/colorwheel.e1c2612b.svg";